import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';

import { CdwDialogContentComponent } from './cdw-dialog-content/cdw-dialog-content.component';
import { CdwConfirmationDialogComponent } from './cdw-confirmation-dialog/cdw-confirmation-dialog.component';
import { CdwExportDialogComponent } from './cdw-export-dialog/cdw-export-dialog.component';
import { CdwExportForBulkEditDialogComponent } from './cdw-export-for-bulk-edit-dialog/cdw-export-for-bulk-edit-dialog.component';
import { CdwImportDialogComponent } from './cdw-import-dialog/cdw-import-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialLibraryModule,
    CdwButtonModule,
    CdwCheckboxModule,
    CdwIconModule,
  ],
  declarations: [
    CdwDialogContentComponent,
    CdwConfirmationDialogComponent,
    CdwExportDialogComponent,
    CdwExportForBulkEditDialogComponent,
    CdwImportDialogComponent,
  ],
  exports: [
    CdwDialogContentComponent,
    CdwConfirmationDialogComponent,
    CdwExportDialogComponent,
    CdwExportForBulkEditDialogComponent,
    CdwImportDialogComponent,
  ],
})
export class CdwDialogModule {}
